import { useEffect, useState } from 'react';
import { useTime } from 'react-time-sync';

export const useCountdownTimer = (countdownSecs = 30) => {
  const currentTime = useTime();
  const [startTime, setStartTime] = useState<number | null>(null);
  const [secs, setSecs] = useState(countdownSecs);

  useEffect(() => {
    if (startTime === null) {
      return;
    }

    const elapsed = Math.floor((Date.now() - startTime) / 1000);
    const remaining = Math.max(countdownSecs - elapsed, 0);
    setSecs(remaining);
  }, [currentTime]);

  const start = () => {
    setStartTime(Date.now());
  };

  const reset = () => {
    setStartTime(null);
    setSecs(countdownSecs);
  };

  const restart = () => {
    setStartTime(Date.now());
    setSecs(countdownSecs);
  };

  return { value: secs, reset, start, restart };
};
